import { render, staticRenderFns } from "./SignUp4.vue?vue&type=template&id=0de6810a&"
import script from "./SignUp4.vue?vue&type=script&lang=ts&"
export * from "./SignUp4.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports